export default defineNuxtPlugin(() => {
	if (import.meta.client) {
		const link = document.createElement('link')
		link.rel = 'stylesheet'
		link.href = '/font/lazy.fonts.css'
		document.head.appendChild(link)
	}
})
